module.exports = __webpack_public_path__ + "static/media/1.76aa0b7f.png";